import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: number;
  category: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function VideoCard({
  id,
  title,
  thumbnail,
  duration,
  views,
  rating,
  isHot,
  isNew,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
          title={title}
        />
        <div className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/70 text-background-50 text-xs">
          {duration}
        </div>
        {isHot && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
            热门
          </div>
        )}
        {isNew && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
            上新
          </div>
        )}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-play-fill text-primary-500 text-xl"></i>
          </div>
        </div>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {rating}
          </span>
          <span>{views}次播放</span>
        </div>
      </div>
    </Link>
  );
}

export function VideoCardSlim({
  id,
  title,
  thumbnail,
  duration,
  views,
  rating,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group flex gap-3 cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg w-40 h-24 flex-shrink-0 bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
          title={title}
        />
        <div className="absolute bottom-1.5 right-1.5 px-1.5 py-0.5 rounded bg-black/70 text-background-50 text-xs">
          {duration}
        </div>
      </div>
      <div className="flex-1 min-w-0 py-1">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {rating}
          </span>
          <span>{views}次播放</span>
        </div>
      </div>
    </Link>
  );
}